var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGokulamLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.43 234.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.45,119.2c26,24.6,51.9,49.1,77.9,73.8,22.3-23.5,44.5-46.9,66.9-70.5-11.8-11-23.6-22-35.6-33.3-1.8,1.9-3.5,3.8-5.3,5.5-8.8,8.9-17.6,17.7-26.4,26.5-3.9,3.9-9.4,4.1-13,.4-3.6-3.6-3.4-9.1.5-13,12.4-12.4,24.7-24.9,37.1-37.3,4.4-4.4,9.3-4.5,13.7-.3,15.7,14.7,31.4,29.3,47.1,44,4.3,4,4.5,9.3.5,13.6-26.2,27.6-52.3,55.2-78.5,82.8-3.7,3.9-9,4-13,.2-14.7-13.9-29.3-27.8-44-41.6-15.2-14.3-30.3-28.6-45.4-43-5.1-4.9-5.3-9.7-.4-14.8,27.9-29.5,55.8-58.9,83.7-88.4,3.5-3.7,7-4.8,10.7-3.3,6,2.3,7.6,9.7,3.2,14.5-8,8.5-16,17-24.1,25.5-18.1,19-36.1,38-54.1,57.1-.5.4-.9.9-1.5,1.6Z",
    fill: "#ec1a15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.85,118c-26-24.6-51.8-49.1-77.9-73.8-22.3,23.5-44.5,46.9-66.9,70.5,11.9,11.1,23.6,22,35.4,33.1.6-.5,1.1-1,1.5-1.5,10.1-10.2,20.2-20.4,30.4-30.5,4.3-4.3,10.8-3.8,14,1,2.4,3.5,2,8-1.1,11.3-2.8,3-5.7,5.8-8.6,8.7-9.6,9.7-19.2,19.4-28.8,29-4.4,4.4-9.3,4.5-13.9.2-15.6-14.6-31.2-29.2-46.8-43.7-4.6-4.3-4.8-9.4-.4-14,25.9-27.4,51.9-54.7,77.9-82.1,4.3-4.5,9.4-4.6,13.9-.3,29.9,28.3,59.7,56.6,89.6,84.9,4.2,3.9,4.4,9.3.4,13.5-28.3,29.9-56.7,59.9-85,89.8-3.8,4-9.3,4.3-13,.8-3.7-3.4-3.7-9.1.1-13,16.6-17.6,33.3-35.2,49.9-52.7,9.4-9.9,18.8-19.9,28.2-29.8.3-.4.6-.8,1.1-1.4Z",
    fill: "#ec1a15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.05,224.2c0-6,4.8-10.8,10.7-10.8s10.7,4.8,10.7,10.8-4.7,10.6-10.8,10.6-10.6-4.6-10.6-10.6Z",
    fill: "#ec1a15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.05,10.8c-.1-6,4.7-10.8,10.7-10.8s10.8,4.7,10.8,10.7-4.7,10.6-10.6,10.7c-6,0-10.8-4.6-10.9-10.6Z",
    fill: "#ec1a15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGokulamLogoIcon);
export default __webpack_public_path__ + "static/media/gokulam-logo-icon.cb68c9207d101802c7bcea2840f67e49.svg";
export { ForwardRef as ReactComponent };